module.exports = __webpack_public_path__ + "img/Income_icon.367f479a.png";